<template>
  <div class="w-full">
    <div class="supplier rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/supply/suppliers')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                     @click="onDeleteSupplier(supplier.id)">Delete</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="onEditSupplier(supplier.id)">Edit</el-button>
          <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                     @click="$router.push('/ecommerce/supply/suppliers/new')">New</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Name:</div></el-col>
        <el-col :span="18">
          <div class="px-4 mb-6">{{ supplier.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Suppliers Group(s):</div></el-col>
        <el-col :span="18">
          <div class="px-4 mb-6"><template v-for="group in supplier.groups">
            <el-tag class="grp" size="medium" type="info">{{group.name}}</el-tag>
          </template></div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Contact Email:</div></el-col>
        <el-col :span="18"><div class="px-4 mb-6">{{ supplier.email }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Contact Phone:</div></el-col>
        <el-col :span="18"><div class="px-4 mb-6">{{ supplier.phone }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Contact Address:</div></el-col>
        <el-col :span="18">
          <div class="px-4 mb-6">
            {{ supplier.address }} {{supplier.city}}, {{supplier.state_name}}, {{supplier.country_name}}
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Contact Person:</div></el-col>
        <el-col :span="18"><div class="px-4 mb-6">{{ supplier.contact_person }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Enabled:</div></el-col>
        <el-col :span="18">
          <div class="px-4 mb-6">
            <template v-if="supplier.status === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SupplierDetails',
  computed: {
    supplier() {
      return this.$store.state.InventoryModule.Suppliers.supplier;
    },
  },
  methods: {
    onEditSupplier(id) {
      this.$router.push(`/ecommerce/supply/suppliers/${id}/edit`);
    },
    onDeleteSupplier(supplierId) {
      this.$confirm('Are you sure you want to delete this supplier?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Suppliers/deleteSupplier', { supplierId });
          this.$notify.success({
            title: 'Success',
            message: 'Supplier has been deleted.',
          });
          await this.$router.push('/ecommerce/supply/suppliers');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('InventoryModule/Suppliers/getSupplier', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>
  .supplier {
    font-size: 15px;
  }
  .grp { margin-right: 5px; }
  .hd {font-weight: 500;}
</style>
